import { Http } from "../axios/interceptors";

export const allOrdersByCompany = async (param) =>
  Http("GET", "/Orders/GetProductsByCompany?", param);

export const getOrderPayment = async (guid) =>
  Http("GET", `/Orders/GetPayment?guidOrder=${guid}`);

export const createOrderPayment = async (body, id = null) =>
  id
    ? Http("PUT", `/Orders/UpdatePayment`, null, body)
    : Http("POST", "/Orders/CreatePayment", null, body);

export const createOrderProduct = async (body) =>
  Http("POST", `/Orders/CreateProducts`, null, body);

export const updateOrderProducts = async (body) =>
  Http("PUT", `/Orders/UpdateProducts`, null, body);

export const getOrder = async (param) => Http("GET", "/Orders/Get?", param);

export const changeStatus = async (body) =>
  Http("PUT", "/Orders/StatusChanges", null, body);

export const deleteProductOrder = async (param) =>
  Http("DELETE", "/Orders/DeleteProducts?", param);

//export const allClientsByCompany = async (param) => Http('GET', `/Clients/GetByCompany?`, param)
// Orders/StatusChanges
//export const getClient = async guid => Http('GET', `/Clients/Get?idClient=${guid}`)

//export const createOrEditClient = async (body, id = null) => (id ? Http('PUT', `/Clients/Update`, null, body) : Http('POST', '/Clients/Create', null, body))

//export const deleteClient = async guid => Http('DELETE', `/Clients/Delete?idClient=${guid}`)
